import { Messages } from '~src/codegen/Localize';

import { PoolNodeStatus } from './PoolNodeStatus';

export type NodeStatus = Readonly<{
  stateLabel: string;
  stateText:  string;
  stateImage: string;
  stateClass: string;
}>;

/*
 * Register remote node status here for the node presence icon
 */
export function gePoolNodeStatus() {
  return {
    'Uninitialized': {
      stateLabel: Messages.dataConnectSiteSettingsPoolStatusUninitialized(),
      stateText: Messages.dataConnectSiteSettingsPoolStatusUninitialized(),
      stateImage: 'status_error_18px-large.svg',
      stateClass: 'tb-remote-agent-presence-icon tb-remote-agent-presence-connected'
    },
    'Ready': {
      stateLabel: Messages.dataConnectSiteSettingsPoolNodeStatusReady(),
      stateText: Messages.dataConnectSiteSettingsPoolNodeStatusReady(),
      stateImage: 'status_active_18px-large.svg',
      stateClass: 'tb-remote-agent-presence-icon tb-remote-agent-presence-connected'
    },
    'Provisioning': {
      stateLabel: Messages.dataConnectSiteSettingsPoolNodeStatusProvisioning(),
      stateText: Messages.dataConnectSiteSettingsPoolNodeStatusProvisioning(),
      stateImage: 'status_inprogress_18px-large.svg',
      stateClass: 'tb-remote-agent-presence-icon tb-remote-agent-presence-not-connected'
    },
    'Error': {
      stateLabel: Messages.dataConnectSiteSettingsPoolNodeStatusError(),
      stateText: Messages.dataConnectSiteSettingsPoolNodeStatusError(),
      stateImage: 'status_error_18px-large.svg',
      stateClass: 'tb-remote-agent-presence-icon tb-remote-agent-presence-not-connected'
    },
    'Warning': {
      stateLabel: Messages.dataConnectSiteSettingsPoolNodeStatusWarning(),
      stateText: Messages.dataConnectSiteSettingsPoolNodeStatusWarning(),
      stateImage: 'status_warning_18x-large.svg',
      stateClass: 'tb-remote-agent-presence-icon tb-remote-agent-presence-not-connected'
    },
    'TokenExpired': {
      stateLabel: Messages.dataConnectSiteSettingsPoolNodeStatusTokenExpired(),
      stateText: Messages.dataConnectSiteSettingsPoolNodeStatusTokenExpired(),
      stateImage: 'status_error_18px-large.svg',
      stateClass: 'tb-remote-agent-presence-icon tb-remote-agent-presence-not-connected'
    },
    'TokenWilExpire': {
      stateLabel: Messages.dataConnectSiteSettingsPoolNodeStatusTokenWillExpire(),
      stateText: Messages.dataConnectSiteSettingsPoolNodeStatusTokenWillExpire(),
      stateImage: 'status_warning_18x-large.svg',
      stateClass: 'tb-remote-agent-presence-icon tb-remote-agent-presence-not-connected'
    }
  } as { readonly [s in PoolNodeStatus]: NodeStatus };
}
